<template>
  <v-sheet v-if="formData.hasOwnProperty('id')">
    <v-layout row wrap>
      <v-flex xs12 md8 class="pb-0 pt-0">
        <h2 class="mb-0">{{ formData.name }}</h2>
      </v-flex>
      <v-flex xs12>
        <v-tabs v-model="activeTab" fixed-tabs>
          <v-tab ripple>Public Profile</v-tab>
          <v-tab ripple>Our Work</v-tab>
          <v-tab ripple>Testimonials</v-tab>
          <v-tab ripple>Services</v-tab>
          <!-- PROFILE DETAILS -->
          <v-tab-item class="mt-5">
            <v-form ref="profileForm">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-flex xs12 class="autoMargin px-2">
                    <template v-if="formData.id">
                      <div v-if="formData.imageUrl && !changeImage">
                        <v-img
                          :src="formData.imageUrl"
                          :width="300"
                          :height="200"
                          class="autoMargin mb-4"
                        />
                        <br />
                        <v-btn
                          small
                          block
                          color="info"
                          @click="changeImage = true"
                          >Change Image</v-btn
                        >
                      </div>
                      <croppa
                        v-if="!formData.imageUrl || changeImage"
                        v-model="image"
                        :show-loading="true"
                        :width="300"
                        :height="200"
                        :quality="2"
                        canvas-color="#FFF"
                        placeholder-color="#000000"
                        placeholder="Choose formData image"
                        style="width: 300px"
                        initial-size="contain"
                      />
                      <div
                        v-if="!formData.imageUrl || changeImage"
                        class="caption text-xs-center"
                      >
                        Use scroll wheel to zoom in / out and drag to
                        reposition.
                      </div>
                    </template>
                  </v-flex>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-textarea
                        v-model="formData.whoAreWe"
                        :rules="[rules.max500]"
                        label="Who are we"
                        counter="500"
                        maxlength="500"
                        rows="5"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="formData.aboutWhatWeDo"
                        :rules="[rules.max500]"
                        label="About what we do"
                        counter="500"
                        maxlength="500"
                        rows="6"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 md6>
                  <v-text-field
                    v-model="formData.website"
                    hide-details
                    label="Website"
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="formData.profilePictureTitle"
                    label="Title of Image"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-tab-item>
          <!-- OUR WORK -->
          <v-tab-item class="mt-5">
            <v-layout row wrap>
              <v-flex xs12>
                <v-btn color="info" @click="openWorkDialog({ idx: -1 })"
                  >Add Work Example</v-btn
                >
                <v-dialog
                  v-model="workItemDialog"
                  persistent
                  max-width="1000px"
                >
                  <v-card>
                    <v-card-text>
                      <v-radio-group v-model="workItem.type">
                        <v-radio
                          label="Image (PNG and JPEG Only)"
                          value="image"
                        />
                        <v-radio
                          label="Video (Youtube Urls Only)"
                          value="video"
                        />
                      </v-radio-group>
                      <div v-if="workItem.type == 'image'" class="subheading">
                        Provide a picture of the work done and a short
                        description
                      </div>
                      <v-container grid-list-md v-if="workItem.type == 'image'">
                        <v-layout row>
                          <div style="flex: 1">
                            <v-flex xs12>
                              <v-text-field
                                v-model="workItem.description"
                                label="Description"
                                counter="100"
                                maxlength="100"
                              />
                            </v-flex>
                            <small
                              v-if="!workItem.imageUrl || changeWorkItemImage"
                            >
                              Actual image will be twice this size
                              <br />Use scroll wheel to zoom in / out and drag
                              to reposition.
                            </small>
                            <v-radio-group
                              v-if="!workItem.imageUrl || changeWorkItemImage"
                              v-model="workItem.imageOrientation"
                            >
                              <v-radio
                                v-for="n in ['Portrait', 'Landscape']"
                                :key="n"
                                :label="n"
                                :value="n"
                              />
                            </v-radio-group>
                          </div>
                          <div style="flex: 1">
                            <v-flex xs12>
                              <div
                                v-if="workItem.imageUrl && !changeWorkItemImage"
                              >
                                <v-img
                                  :src="workItem.imageUrl"
                                  :width="
                                    workItem.imageOrientation == 'Landscape'
                                      ? 400
                                      : 300
                                  "
                                  :height="
                                    workItem.imageOrientation == 'Landscape'
                                      ? 300
                                      : 400
                                  "
                                  class="autoMargin"
                                />
                                <v-btn
                                  small
                                  block
                                  color="info"
                                  @click="changeWorkItemImage = true"
                                  >Change Image</v-btn
                                >
                              </div>
                              <croppa
                                v-if="!workItem.imageUrl || changeWorkItemImage"
                                v-model="workItemImage"
                                :show-loading="true"
                                :width="
                                  workItem.imageOrientation == 'Landscape'
                                    ? 400
                                    : 300
                                "
                                :height="
                                  workItem.imageOrientation == 'Landscape'
                                    ? 300
                                    : 400
                                "
                                :quality="2"
                                :style="`width:${
                                  workItem.imageOrientation == 'Landscape'
                                    ? 400
                                    : 300
                                }px`"
                                canvas-color="#FFF"
                                placeholder-color="#000000"
                                placeholder="Choose profile image"
                                initial-size="contain"
                              />
                            </v-flex>
                          </div>
                        </v-layout>
                      </v-container>
                      <v-container grid-list-md v-if="workItem.type == 'video'">
                        <v-layout row>
                          <div style="flex: 1">
                            <v-flex xs12>
                              <v-text-field
                                v-model="workItem.description"
                                label="Description"
                                counter="100"
                                maxlength="100"
                              />
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="workItem.videoUrl"
                                label="Video Url"
                              />
                            </v-flex>
                          </div>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        flat
                        @click="workItemDialog = false"
                        >Close</v-btn
                      >
                      <v-btn
                        :loading="saving"
                        v-if="workItem.type == 'image'"
                        color="success"
                        @click="saveWorkItem()"
                        >Save</v-btn
                      >
                      <v-btn
                        :loading="saving"
                        v-if="workItem.type == 'video'"
                        color="success"
                        @click="saveWorkItemVideo()"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-card flat>
                  <v-card-text>
                    <v-layout key="ourWork" wrap justify-center>
                      <v-flex
                        v-for="(work, index) in formData.ourWork"
                        :key="`work_${index}`"
                        xs6
                        sm4
                      >
                        <v-card>
                          <v-img
                            v-if="work.imageUrl"
                            :src="work.imageUrl"
                            height="200px"
                          >
                            <v-container fill-height fluid pa-2>
                              <v-layout fill-height>
                                <v-flex xs12 align-end flexbox />
                              </v-layout>
                            </v-container>
                          </v-img>
                          <silentbox-single v-else :src="work.videoUrl">
                            <v-img
                              height="200px"
                              :src="`https://img.youtube.com/vi/${work.videoID}/hqdefault.jpg`"
                            >
                              <v-container fill-height fluid pa-2>
                                <v-layout fill-height>
                                  <v-flex xs12 align-end flexbox />
                                </v-layout>
                              </v-container>
                            </v-img>
                          </silentbox-single>
                          <v-card-title primary-title>
                            <div>
                              <span>{{ work.description }}</span>
                            </div>
                          </v-card-title>
                          <v-card-actions>
                            <v-spacer />
                            <v-btn
                              icon
                              @click="
                                work.idx = index;
                                openWorkDialog(work);
                              "
                            >
                              <v-icon color="blue">mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn icon @click="deleteWorkItem(work)">
                              <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                          </v-card-actions>
                          <v-card-actions>
                            <v-btn
                              v-if="index !== 0"
                              icon
                              @click="moveUp(index)"
                            >
                              <v-icon color="blue">mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-spacer />
                            <v-btn
                              v-if="index !== formData.ourWork.length - 1"
                              icon
                              @click="moveDown(index)"
                            >
                              <v-icon color="blue">mdi-chevron-right</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item class="mt-5">
            <v-layout row wrap>
              <v-flex xs12>
                <v-dialog
                  v-model="testimonialDialogBox"
                  persistent
                  max-width="1000px"
                >
                  <v-card>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout row>
                          <div style="flex: 1">
                            <v-flex xs12>
                              <v-textarea
                                v-model="testimonialItem.message"
                                label="Description"
                                counter="225"
                                maxlength="225"
                                :disabled="!userData.role.includes('Admin')"
                              />
                            </v-flex>
                            <v-flex xs12>
                              <v-checkbox
                                v-if="!testimonialItem.featured"
                                v-model="testimonialItem.visible"
                                label="Visible"
                              />
                              <v-checkbox
                                v-else
                                v-model="testimonialItem.visible"
                                disabled
                                label="Visible"
                              />
                              <v-checkbox
                                v-model="testimonialItem.featured"
                                @change="featuredTestimonial()"
                                label="Featured"
                              />
                            </v-flex>
                          </div>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        flat
                        @click="testimonialDialogBox = false"
                        >Close</v-btn
                      >
                      <v-btn
                        :loading="saving"
                        color="success"
                        @click="saveTestimonialItem()"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-card flat>
                  <v-card-text>
                    <v-layout key="testimonial" wrap justify-center>
                      <v-flex
                        v-for="(testimonial, index) in formData.testimonial"
                        :key="`testimonial_${index}`"
                        xs6
                        sm4
                      >
                        <v-card>
                          <v-card-title primary-title>
                            <div>
                              {{ testimonial.fullName }}
                              <v-icon
                                v-if="
                                  testimonial.visible || testimonial.featured
                                "
                                color="blue"
                                >mdi-eye</v-icon
                              >
                              <v-icon v-else color="blue">mdi-eye-off</v-icon>
                              <v-icon v-if="testimonial.featured" color="yellow"
                                >mdi-star</v-icon
                              >
                            </div>
                          </v-card-title>
                          <v-card-text>
                            <div>
                              <span>{{ testimonial.message }}</span>
                            </div>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer />
                            <v-btn
                              icon
                              @click="
                                testimonial.idx = index;
                                openTestimonialDialog(testimonial);
                              "
                            >
                              <v-icon color="blue">mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn icon @click="deleteTestimonial(testimonial)">
                              <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                          </v-card-actions>
                          <!-- <v-card-actions>
                            <v-btn v-if="index !== 0" icon @click="testimonialMoveUp(index)">
                              <v-icon color="blue">mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-spacer />
                            <v-btn
                              v-if="index !== (formData.testimonial.length - 1)"
                              icon
                              @click="testimonialMoveDown(index)"
                            >
                              <v-icon color="blue">mdi-chevron-right</v-icon>
                            </v-btn>
                          </v-card-actions>-->
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item class="mt-5">
            <v-layout row wrap>
              <v-flex xs12>
                <v-card flat>
                  <v-card-text>
                    <div class="title">
                      Provide a list of services your business offers under each
                      sub category
                    </div>
                    <div class="caption">
                      Add the services that your business offers
                      <br />ONLY services that are already loaded by Upstream
                      admin will show - we do this so we never have a NO RESULTS
                      page <br />If a service you are looking for doesn't appear
                      please fill
                      <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeJS-ileUr7uTJJ7h7oiU-3N8Qx1WKbrb3RVNpmSwc9cO-YBQ/viewform"
                        >this form</a
                      >
                      to request it.
                      <br />Click on the end of the list to add a new item.
                      <br />
                      <strong>
                        The first set of services will be displayed publically
                        on your profile. The second set will only be used as
                        additional key words in searches.
                      </strong>
                    </div>
                    <v-layout key="services" wrap justify-center>
                      <v-flex xs12>
                        <v-autocomplete
                          v-if="formData.id === '32'"
                          v-model="formData.services"
                          :items="services"
                          hide-selected
                          chips
                          color="blue lighten-2"
                          label="Enter services"
                          multiple
                          deletable-chips
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                          v-if="formData.id !== '32'"
                          v-model="formData.services"
                          :items="services"
                          hide-selected
                          chips
                          color="blue lighten-2"
                          label="What You Offer"
                          hint="Enter services you offer that will be displayed on your listing profile"
                          multiple
                          deletable-chips
                          persistent-hint
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                          v-if="formData.id !== '32'"
                          v-model="formData.searchServices"
                          :items="services"
                          hide-selected
                          chips
                          color="blue lighten-2"
                          label="What Your Are / Other Keywords"
                          hint="Enter additional services or keywords that will be used in searches. These won't be displayed on your listing profile, but the customer searches these words, your listing will show as a result"
                          multiple
                          deletable-chips
                          persistent-hint
                        />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs>
      </v-flex>

      <v-flex xs12>
        <v-btn :loading="saving" @click="save()" color="success"> Save </v-btn>
      </v-flex>
    </v-layout>
  </v-sheet>
  <v-sheet v-else>
    <div style="margin: auto; width: 50px; padding-top: calc(25% - 25px)">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-sheet>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    props: ["id"],
    computed: {
      ...mapGetters({
        userData: "user/userData",
        profile: "business/currentProfile",
        goodCauses: "goodCauses/listOrderedByCategories",
        services: "business/services",
        categories: "categories/list",
        categoriesByName: "categories/byName",
        tally: "clicks/tallyData",
      }),
    },
    watch: {
      id: function () {
        this.$store.dispatch("business/loadProfile", this.id);
      },
      profile: function () {
        this.open(JSON.parse(JSON.stringify(this.profile)), this.id);
      },
    },
    data: () => ({
      changeImage: false,
      image: null,
      formData: {},
      visibilityStatus: [
        {
          value: "Live Report",
          title: "Report visible to public",
        },
        {
          value: "Data Only",
          title: "Report hidden from public",
        },
      ],
      saving: false,
      rules: {
        max400: (value) => !value || value.length <= 400 || "Max 400 characters",
        max500: (value) => !value || value.length <= 500 || "Max 500 characters",
        max600: (value) => !value || value.length <= 600 || "Max 600 characters",
        max180: (value) => !value || value.length <= 180 || "Max 180 characters",
      },
      activeTab: null,

      statusList: [
        "Admin",
        "Prospecting",
        "Drafting",
        "Approved & Live",
        "Paused / Live",
        "Left & Removed",
      ],
      address: "",
      rules: {
        max400: (value) => !value || value.length <= 400 || "Max 400 characters",
        max500: (value) => !value || value.length <= 500 || "Max 500 characters",
        max600: (value) => !value || value.length <= 600 || "Max 600 characters",
        max180: (value) => !value || value.length <= 180 || "Max 180 characters",
      },
      testimonialDialogBox: false,
      selectCity: [],
      selectRegion: [],
      locations: [],
      fullLocationData: [],
      regions: [
        "Nationwide",
        "Auckland",
        "Bay Of Plenty",
        "Canterbury",
        "Gisborne",
        "Hawke's Bay",
        "Manawatu/Whanganui",
        "Marlborough",
        "Nelson/Tasman",
        "Northland",
        "Otago",
        "Southland",
        "Taranaki",
        "Waikato",
        "Wellington",
        "West Coast",
      ],
      cities: [
        "Far North",
        "Kaipara",
        "Whangarei",
        "Auckland City",
        "Franklin",
        "Hauraki Gulf Islands",
        "Manukau City",
        "North Shore City",
        "Papakura",
        "Rodney",
        "Waiheke Island",
        "Waitakere City",
        "Hamilton",
        "Hauraki",
        "Matamata-Piako",
        "Otorohanga",
        "South Waikato",
        "Taupo",
        "Thames-Coromandel",
        "Waikato",
        "Waipa",
        "Waitomo",
        "Kawerau",
        "Opotiki",
        "Rotorua",
        "Tauranga",
        "Western Bay Of Plenty",
        "Whakatane",
        "Gisborne",
        "Central Hawke's Bay",
        "Hastings",
        "Napier",
        "Wairoa",
        "New Plymouth",
        "South Taranaki",
        "Stratford",
        "Horowhenua",
        "Manawatu",
        "Palmerston North",
        "Rangitikei",
        "Ruapehu",
        "Tararua",
        "Whanganui",
        "Carterton",
        "Kapiti Coast",
        "Lower Hutt",
        "Masterton",
        "Porirua",
        "South Wairarapa",
        "Upper Hutt",
        "Wellington",
        "Nelson",
        "Tasman",
        "Blenheim",
        "Kaikoura",
        "Marlborough",
        "Buller",
        "Grey",
        "Westland",
        "Ashburton",
        "Banks Peninsula",
        "Christchurch City",
        "Hurunui",
        "Mackenzie",
        "Selwyn",
        "Timaru",
        "Waimakariri",
        "Waimate",
        "Central Otago",
        "Clutha",
        "Dunedin",
        "Queenstown-Lakes",
        "South Otago",
        "Waitaki",
        "Wanaka",
        "Catlins",
        "Gore",
        "Invercargill",
        "Southland",
      ],
      testimonialItem: {},
      learnMoreItem: {},
      learnMoreDialogBox: false,
      menuDate: false,
      menuDateOn: false,
      deleting: false,
      workOptions: [
        { val: "image", label: "Image (PNG and JPEG Only)" },
        { val: "video", label: "Video (Youtube Urls Only)" },
      ],
      promotionFileChangeChoice: "",
      changePromotionFileDialog: false,
      fileData: {},
      includeFileData: false,
      imageOrientation: "Landscape",
      workItemDialog: false,
      changeWorkItemImage: false,
      workItem: {},
      image: null,
      workItemImage: null,
      changeImage: false,
      activeTab: null,
      saving: false,
      formData: {},
      searchSuppliers: "",

      // Impact Report
      impactReportFound: false,
      impactReportData: {},
      createImpactReportLoading: false,

      clipboardTextData: "",
    }),
    mounted() {
      this.$store.dispatch("business/loadProfile", this.id);
    },
    methods: {
      save(keepOpen) {
        if (this.$refs.profileForm.validate()) {
          this.saving = true;
          let payload = JSON.parse(JSON.stringify(this.formData));
          // Clean up Data
          let relationalData = [
            "ourWork",
            "learnMore",
            "testimonial",
            "locationsJSON",
          ];
          payload.serviceDistricts = this.selectRegion;
          payload.serviceRegions = this.selectCity;
          payload.locations = this.locations;
          for (const prop in payload) {
            if (!relationalData.includes(prop) && Array.isArray(payload[prop])) {
              payload[prop] = payload[prop].toString();
            }
          }
          if (payload.searchWeight == "") {
            delete payload.searchWeight;
          }
          payload.locationsJSON = JSON.stringify(this.fullLocationData);
          if (this.image && this.image.imageSet) {
            payload.image = {
              dataUrl: this.image.generateDataUrl(),
            };
          } else {
            delete payload.image;
          }
          this.$store.dispatch("business/save", payload).then((business) => {
            this.saving = false;

            if (business.category != "" && typeof business.category != "object") {
              business.category = business.category.split(",");
            }
            if (
              business.subCategory != "" &&
              typeof business.subCategory != "object"
            ) {
              business.subCategory = business.subCategory.split(",");
            }
            business.testimonial.forEach((element) => {
              element.visible = parseInt(element.visible);
              element.featured = parseInt(element.featured);
            });
            this.formData = business;
            this.formData.isGstRegistered = parseInt(
              this.formData.isGstRegistered
            );

            this.changeImage = false;
            this.workItemDialog = false;
            this.workItemImage = null;
            this.workItem = {};
            this.learnMoreDialogBox = false;
            this.fileData = {};
            this.changePromotionFileDialog = false;
            this.testimonialDialogBox = false;

            this.fileData = {};
          });
        }
      },
      open(business, id) {
        this.saving = false;
        this.image = null;
        if (business.category != "" && typeof business.category != "object") {
          business.category = business.category.split(",");
        }
        if (
          business.subCategory != "" &&
          typeof business.subCategory != "object"
        ) {
          business.subCategory = business.subCategory.split(",");
        }
        business.testimonial.forEach((element) => {
          element.visible = parseInt(element.visible);
          element.featured = parseInt(element.featured);
        });

        this.formData = business;
        this.formData.isGstRegistered = parseInt(this.formData.isGstRegistered);
        this.$forceUpdate;
        if (business.locations != "") {
          this.locations = business.locations.split(",");
        }
        if (business.serviceDistricts != "") {
          this.selectCity = business.serviceDistricts.split(",");
        }
        if (business.serviceRegions != "") {
          this.selectRegion = business.serviceRegions.split(",");
        }
      },

      // Testimonial
      openTestimonialDialog(item) {
        this.testimonialItem = item;
        this.testimonialDialogBox = true;
      },
      featuredTestimonial(testimonialItem) {
        if (this.testimonialItem.featured === true) {
          this.testimonialItem.visible = true;
        }
      },
      saveTestimonialItem() {
        this.saving = true;

        this.formData.testimonial[this.testimonialItem.idx] =
          this.testimonialItem;

        this.save(true);
      },

      // Our Work
      moveDown(idx) {
        let b = this.$clone(this.formData.ourWork[idx + 1]);
        b.idx = this.formData.ourWork[idx + 1].idx = idx;
        this.formData.ourWork[idx + 1] = this.formData.ourWork[idx];
        this.formData.ourWork[idx + 1].idx = idx + 1;
        this.formData.ourWork[idx] = b;
        this.save(true);
      },
      moveUp(idx) {
        let b = this.$clone(this.formData.ourWork[idx - 1]);
        b.idx = this.formData.ourWork[idx - 1].idx = idx;
        this.formData.ourWork[idx - 1] = this.formData.ourWork[idx];
        this.formData.ourWork[idx - 1].idx = idx - 1;
        this.formData.ourWork[idx] = b;
        this.save(true);
      },
      openWorkDialog(item) {
        this.changeWorkItemImage = false;
        this.workItem = item;
        this.workItemDialog = true;
        this.workItemDialog = true;
      },
      saveWorkItem() {
        this.saving = true;
        this.workItem.business_id = this.formData.id;
        if (this.workItemImage && this.workItemImage.imageSet) {
          this.workItemImage.generateBlob(
            (blob) => {
              this.workItem.image = { file: blob };
              if (!this.formData.ourWork) {
                this.formData.ourWork = [];
              }
              if (this.workItem.idx === -1) {
                this.workItem.idx = this.formData.ourWork.length;
              }
              this.$store
                .dispatch("business/saveWorkItemImage", this.workItem)
                .then((workItemUrl) => {
                  this.workItem.imageUrl = workItemUrl;
                  delete this.workItem.image;
                  this.formData.ourWork[this.workItem.idx] = this.workItem;

                  this.save(true);
                });
            },
            "image/jpeg",
            1
          );
        } else {
          this.formData.ourWork[this.workItem.idx] = this.workItem;
          this.save(true);
        }
      },
      saveWorkItemVideo() {
        this.saving = true;
        if (!this.formData.ourWork) {
          this.formData.ourWork = [];
        }
        if (this.workItem.idx === -1) {
          this.workItem.idx = this.formData.ourWork.length;
        }
        let VID_REGEX =
          /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        let videoID = this.workItem.videoUrl.match(VID_REGEX)[1];
        this.workItem.videoID = videoID;
        this.workItem.business_id = this.formData.id;
        this.formData.ourWork[this.workItem.idx] = this.workItem;

        this.save(true);
      },
      deleteWorkItem(workItem) {
        this.$confirm("Are you sure you want to delete this work example?").then(
          (res) => {
            if (res) {
              this.deleting = true;
              // this.formData.ourWork.splice(
              //   this.formData.ourWork[workItem.idx],
              //   1
              // );
              this.$store
                .dispatch("business/deleteOurWork", workItem.id)
                .then((res) => {
                  this.deleting = false;
                  let ourWork = this.formData.ourWork.filter(
                    (OW) => OW != workItem
                  );
                  this.formData.ourWork = ourWork;
                });
            }
          }
        );
      },

      // Misc
      fileChange(ev) {
        const file = ev.target.files[0];
        this.fileData.data = file;
        this.fileData.meta = { name: file.name, type: file.type };
        let extension = file.name.split(".");
        if (this.promotionFileChangeChoice == "LearnMore") {
          this.fileData.meta.name = `${Date.now()}_${this.formData.id}_${
            this.promotionFileChangeChoice
          }.${extension[extension.length - 1]}`;
        } else {
          this.fileData.meta.name = `${this.formData.id}_${
            this.promotionFileChangeChoice
          }.${extension[extension.length - 1]}`;
        }
      },
    },
  };
</script>
